/**
 * Implementação do repositório de ReminderSettings: orquestra datasource remoto e local.
 */

import type { ReminderSettings } from '@/core/domain';
import type { ReminderSettingsRepository } from '../../domain/repositories/reminder-settings-repository';
import type { ReminderSettingsRemoteDataSource } from '../datasources/remote';
import type { ReminderSettingsLocalDataSource } from '../datasources/local';

export class ReminderSettingsRepositoryImpl implements ReminderSettingsRepository {
  constructor(
    private readonly remote: ReminderSettingsRemoteDataSource,
    private readonly local: ReminderSettingsLocalDataSource
  ) {}

  async getById(userId: string): Promise<ReminderSettings | null> {
    const fromCache = await this.local.getById(userId);
    if (fromCache != null) return fromCache;
    const fromRemote = await this.remote.getById(userId);
    if (fromRemote != null) await this.local.create(fromRemote).catch(() => {});
    return fromRemote;
  }

  async create(userId: string, settings: ReminderSettings): Promise<ReminderSettings> {
    const created = await this.remote.create(userId, settings);
    await this.local.create(created).catch(() => {});
    return created;
  }

    async update(userId: string, id: string, settings: Partial<ReminderSettings>): Promise<ReminderSettings> {
    const updated = await this.remote.update(userId, id, settings);
    await this.local.update(id, updated).catch(() => {});
    return updated;
  }

  async delete(userId: string, id: string): Promise<void> {
    await this.remote.delete(userId, id);
    await this.local.delete(id).catch(() => {});
  }

  subscribeMessageTestSendedFlag(
    userId: string,
    onNext: (sended: boolean) => void,
    onError?: (error: Error) => void
  ): () => void {
    return this.remote.subscribeMessageTestSendedFlag(userId, onNext, onError);
  }
}
